import script from "./DateElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./DateElement.vue?vue&type=script&lang=ts&setup=true"

import "./DateElement.vue?vue&type=style&index=0&id=af35af56&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af35af56"]])

export default __exports__